/**
 * "ESSAYEZ DÈS MAINTENANT" / Try Now → scroll to and select the 2nd bundle offer.
 */
(function () {
  'use strict';

  if (window.__eliosTryNowBundleInit) return;
  window.__eliosTryNowBundleInit = true;

  var HASH = 'elios-bundle-offer';
  var MOON_OPTION = '.moonbundle-option-wrapper';
  var RAPI_BAR = '.rapi-bundles__bar';
  var CTA_SELECTOR = 'a.elios-try-now-cta, a[href*="#elios-bundle-offer"]';

  function getSecondMoonOption() {
    var options = document.querySelectorAll(MOON_OPTION);
    if (!options.length) return null;
    return options[1] || options[0];
  }

  function getSecondRapiBar() {
    var bars = document.querySelectorAll(RAPI_BAR);
    if (!bars.length) return null;
    return bars[1] || bars[0];
  }

  function enableUpsellToggles(scope) {
    if (!scope) return;

    scope
      .querySelectorAll(
        'input[type="checkbox"], input[type="radio"].moonbundle-upsell-checkbox, .moonbundle-upsell-item input, [class*="upsell"] input[type="checkbox"]'
      )
      .forEach(function (input) {
        if (input.disabled || input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

    scope.querySelectorAll('[role="switch"], .moonbundle-switch, [class*="toggle"], [class*="switch"]').forEach(function (el) {
      var pressed = el.getAttribute('aria-checked') || el.getAttribute('aria-pressed');
      if (pressed === 'true') return;
      if (el.classList && (el.classList.contains('is-on') || el.classList.contains('active') || el.classList.contains('checked'))) {
        return;
      }
      el.click();
    });
  }

  function selectMoonOption(option) {
    if (!option) return;

    var radio = option.querySelector('input[type="radio"]');
    if (radio && !radio.disabled) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var target =
      option.querySelector('#moonbundle-option, .moonbundle-option[role="button"], .moonbundle-option, [role="radio"]') ||
      option;
    if (target && typeof target.click === 'function') {
      target.click();
    }

    enableUpsellToggles(option);
  }

  function selectRapiBar(bar) {
    if (!bar) return;

    var radio = bar.querySelector('input[type="radio"]');
    if (radio && !radio.disabled) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    bar.click();
    enableUpsellToggles(bar);
  }

  function headerOffset() {
    var header = document.querySelector('sticky-header, .shopify-section--header, #shopify-section-header, header');
    if (!header) return 88;
    return Math.ceil(header.getBoundingClientRect().height) + 16;
  }

  function scrollToEl(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function apply() {
    var moon = getSecondMoonOption();
    var rapi = getSecondRapiBar();
    var fallback = document.getElementById(HASH);
    var target = moon || rapi || fallback;

    if (moon) selectMoonOption(moon);
    else if (rapi) selectRapiBar(rapi);

    if (target) scrollToEl(target);
    return !!(moon || rapi);
  }

  function goToSecondOffer() {
    if (apply()) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (apply() || tries > 40) window.clearInterval(timer);
    }, 150);
  }

  function isSameProductPage(anchor) {
    var href = (anchor && anchor.getAttribute('href')) || '';
    if (href.charAt(0) === '#') return true;

    try {
      var url = new URL(href, window.location.origin);
      return url.pathname === window.location.pathname;
    } catch (err) {
      return href.indexOf('#') !== -1;
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest(CTA_SELECTOR);
    if (!link) return;
    if (!isSameProductPage(link)) return;

    event.preventDefault();
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + HASH);
    }
    goToSecondOffer();
  });

  function maybeOpenFromHash() {
    if (window.location.hash === '#' + HASH) goToSecondOffer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeOpenFromHash);
  } else {
    maybeOpenFromHash();
  }

  window.addEventListener('hashchange', maybeOpenFromHash);
  window.addEventListener('load', maybeOpenFromHash);
})();
